import React, { Suspense } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { i18n, I18nextProvider } from 'i18n';
import { browserHistory } from 'Helper/history';
import AlertLayout from 'Containers/AlertLayout';
import PrivateLayout from 'Containers/PrivateLayout';
import PublicLayout from 'Containers/PublicLayout';
import PrivacyPolicy from 'Screens/PrivacyPolicy';
import 'Customize';
import ReactTracker from 'react-tracker-teko';

const App = (props) => {
  let reactTracker = null;
  if (window.TRACKING_APP_ID) {
    reactTracker = new ReactTracker({
      // Configure your tracker server and site by providing
      host: window.INGESTOR_ENDPOINT || "https://tracking.tekoapis.com",
      urlServeJsFile:
        "https://cdn.tekoapis.com/tracker/dist/v2/tracker.full.min.js",
      appId: window.TRACKING_APP_ID,
    });
    window.track("enableTrackVisibleContentImpressions");
    (function() {
      const originalOpen = XMLHttpRequest.prototype.open;
      const originalSend = XMLHttpRequest.prototype.send;
      const originalSetRequestHeader = XMLHttpRequest.prototype.setRequestHeader;
      const blacklistKeys = window.MASKED_KEYS || [
        'password',
        'current_password',
        'new_password',
        'currentPassword',
        'newPassword',
        'secret',
        'token',
        'access_token',
        'accessToken',
      ];
      const hideSensitiveData = (data) => {
        try {
          const jsonData = JSON.parse(data);
          const finalData = {};
          Object.keys(jsonData).forEach(key => {
            if (!blacklistKeys.includes(key)) {
              finalData[key] = jsonData[key];
            } else {
              finalData[key] = '**********';
            }
          })
          return finalData;
        } catch (e) {
          return {
            raw: data
          };
        }
      }

      XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
        this._method = method;
        this._url = url;
        this._requestHeaders = {};
        return originalOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.setRequestHeader = function(header, value) {
        this._requestHeaders[header] = value;
        return originalSetRequestHeader.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function(body) {
        this._body = body;

        this.addEventListener('readystatechange', function() {
          if (this.readyState === 4) {
            if (this.status >= 400) {
              const apiInfo = {
                "url": this._url,
                "method": this._method,
                "request_headers": this._requestHeaders,
                "request_body": hideSensitiveData(this._body),
                "response_headers": this.getAllResponseHeaders(),
                "response_status": this.status,
                "response_body": this.responseText
              }
              window.track("customEvent", "errorApi" , {
                action: "apiCall",
                property: JSON.stringify(apiInfo),
              });
            }
          }
        });

        return originalSend.apply(this, arguments);
      };
    })();
  } else {
    console.warn("No tracking app id found! Ignore tracker")
  }

  return (
    <Router history={reactTracker ? reactTracker.connectToHistory(browserHistory) : browserHistory}>
      <I18nextProvider i18n={i18n}>
        <Suspense fallback=''>
          <Switch>
            <Route exact path='/privacy' component={PrivacyPolicy} />
            <Route path='/alert' component={AlertLayout} />
            <Route path='/user' component={PrivateLayout} />
            <Route path='/' component={PublicLayout} />
          </Switch>
        </Suspense>
      </I18nextProvider>
    </Router>
  );
};

export default App;
